export default __webpack_public_path__ + "static/media/ic_product_uniqa-vorsorge.e8be9c99.svg";